export default "__VITE_ASSET__B8whgs12__"